import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import axios from "axios";
import { Button, Icon } from "semantic-ui-react";
import { getAuthHttpHeaders } from "../auth";
import { formatDateTimeFromApi } from "../utils/dateTime";
import { id2BgColor } from "../utils/colorUtils";
import CurrencyPair from "../components/CurrencyPair";

@inject("store")
@observer
class CandleSticksDownloadStatus extends Component {
  state = {
    downloadStatus: undefined,
  };

  componentDidMount() {
    this.load();
    this.refreshTimer = setInterval(() => {
      this.load();
    }, 60 * 1000);
  }

  componentWillUnmount() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }

  load = async () => {
    this.setState({ loading: true });

    try {
      let axiosRequest = axios.create({
        baseURL: "api",
        headers: {
          Accept: "application/json",
          ...getAuthHttpHeaders(),
        },
      });

      let response = await axiosRequest.get("exchangeAccount/candleSticks/downloadStatus");
      this.setState({ downloadStatus: response.data });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { downloadStatus } = this.state;
    const {
      store: { zoneId },
    } = this.props;

    const buttons = (
      <Button.Group>
        <Button content="Refresh" icon="refresh" onClick={this.load} loading={this.state.loading} />
      </Button.Group>
    );

    return (
      <div>
        <h1>Candle Sticks Download Status</h1>
        {buttons}
        {downloadStatus &&
          Object.entries(downloadStatus).map(([exchangeType, exchangeData]) => {
            if (!exchangeData || Object.keys(exchangeData).length === 0) {
              return null;
            }
            return (
              <div key={exchangeType} style={{ margin: 30 }}>
                <h2 style={{ backgroundColor: id2BgColor(exchangeType) }}>{exchangeType}</h2>
                <div>
                  {Object.entries(exchangeData).map(([period, periodData]) => {
                    return (
                      <div key={period} style={{ margin: 15 }}>
                        <h3>{period}</h3>
                        <div>
                          {Object.entries(periodData).map(([ccyPair, ccyPairData]) => {
                            return (
                              <div
                                key={ccyPair}
                                title={JSON.stringify(ccyPairData, null, 2).replace(/\\n\\tat/g, " ")}
                                style={{
                                  display: "inline-block",
                                  margin: 3,
                                  minWidth: 150,
                                  verticalAlign: "top",
                                  border: "solid 1px #ccc",
                                  borderRadius: 6,
                                  padding: 3,
                                }}
                              >
                                <CurrencyPair exchangeType={exchangeType} currencyPair={ccyPair} />
                                {ccyPairData.lastCheckException && (
                                  <Icon
                                    name="warning circle"
                                    color="red"
                                    title={ccyPairData.lastCheckException.split("\n")[0]}
                                  />
                                )}
                                {!ccyPairData.lastCheckFinishTime &&
                                  (ccyPairData.lastCheckStartTime ? (
                                    <Icon name="hourglass half" title="Running" />
                                  ) : (
                                    <Icon name="hourglass start" color="grey" title="Init" />
                                  ))}
                                <br />
                                <span title="Last stick end">
                                  {formatDateTimeFromApi(ccyPairData.lastStickEnd, zoneId)}
                                </span>
                                &nbsp;
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        {downloadStatus && buttons}
      </div>
    );
  }
}

export default CandleSticksDownloadStatus;



// WEBPACK FOOTER //
// ./src/exchangeAccounts/CandleSticksDownloadStatus.js